import { render } from "./PhotoWall.vue?vue&type=template&id=8fafa31c"
import script from "./PhotoWall.vue?vue&type=script&lang=js"
export * from "./PhotoWall.vue?vue&type=script&lang=js"
script.render = render

export default script